// Multiplayer relay client. Streams local player state, receives all players.
export class GameNet {
  constructor() {
    this.ws = null;
    this.selfId = 'p-' + Math.random().toString(36).slice(2, 10);
    this.connected = false;
    this.serverPhase = null;
    this.serverTimeLeft = 0;
    this.matchId = null;
    this.onSnapshot = null;   // (players[]) => void, excludes self
    this.onStatus = null;     // (bool) => void
    this._join = null;
    this._reconnectT = null;
    this._closed = false;
  }

  _url() {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    return base.replace(/^http/, 'ws') + '/api/ws';
  }

  connect(joinInfo) {
    this._join = { type: 'join', id: this.selfId, ...joinInfo };
    this._closed = false;
    this._open();
  }

  _open() {
    if (this._closed) return;
    try {
      this.ws = new WebSocket(this._url());
    } catch (e) {
      this._scheduleReconnect();
      return;
    }
    this.ws.onopen = () => {
      this.connected = true;
      if (this.onStatus) this.onStatus(true);
      if (this._join) this.ws.send(JSON.stringify(this._join));
    };
    this.ws.onmessage = (ev) => {
      let msg;
      try { msg = JSON.parse(ev.data); } catch { return; }
      if (msg.type === 'snapshot') {
        this.serverPhase = msg.phase;
        this.serverTimeLeft = msg.time_left;
        this.matchId = msg.match_id;
        if (this.onSnapshot) this.onSnapshot(msg.players.filter((p) => p.id !== this.selfId), msg.count);
      }
    };
    this.ws.onclose = () => {
      this.connected = false;
      if (this.onStatus) this.onStatus(false);
      this._scheduleReconnect();
    };
    this.ws.onerror = () => { try { this.ws.close(); } catch {} };
  }

  _scheduleReconnect() {
    if (this._closed || this._reconnectT) return;
    this._reconnectT = setTimeout(() => {
      this._reconnectT = null;
      this._open();
    }, 2000);
  }

  send(state) {
    if (this.ws && this.connected && this.ws.readyState === 1) {
      this.ws.send(JSON.stringify({ type: 'update', id: this.selfId, ...state }));
    }
  }

  close() {
    this._closed = true;
    if (this._reconnectT) { clearTimeout(this._reconnectT); this._reconnectT = null; }
    if (this.ws) { try { this.ws.close(); } catch {} this.ws = null; }
  }
}
